<template>
  <div
    id="app"
    class="app-viewport"
  >
    <md-whiteframe
      md-elevation="3"
      class="main-toolbar"
      v-show="toolbarActive"
    >
      <md-toolbar class="md-dense">
        <md-button
          class="md-icon-button"
          v-show="!isRouterPath('home')"
          @click="$router.go(-1)"
        >
          <md-icon>arrow_back</md-icon>
        </md-button>
        <h2
          class="md-title"
          style="flex:1"
        >{{title}}</h2>
        <md-menu v-show="blh">
          <md-button
            md-menu-trigger
            class="md-icon-button"
          >
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content>
            <md-menu-item>V2.9.1</md-menu-item>
            <!-- <md-menu-item @selected="sync()">Sincronizar dados</md-menu-item> -->
            <md-menu-item @selected="logout()">Sair</md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-toolbar>
    </md-whiteframe>
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapState({
      blh: state => state.blh
    }),
    user () {
      return {}
    },
    memoryAvaiable () {

    },
    userAgent () {

    },
    title () {
      let name = ''
      if (this.blh) {
        name = ' ' + this.blh.name.trim()
      }
      switch (this.$route.path) {
        case '/areas':
          return 'Instalações' + name
        case '/structures':
          return 'Equipamentos' + name
        case '/photos':
          return 'Fotos' + name
        default:
          return name
      }
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    toolbarActive () {
      let path = this.$route.path
      return path !== '/' && path !== '/camera'
    }
  },
  // beforeMount(){
  //     let vm = this
  //     navigator.webkitTemporaryStorage.queryUsageAndQuota(
  //       function(usedBytes, grantedBytes) {
  //         console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes')
  //         if (grantedBytes - usedBytes <= 4000000) {
  //           console.log('TAMANHO INSUFICIENTE PARA PROSSEGUIR COM O PROCESSO')
  //           vm.quotaExceeded = true
  //         } else {
  //           vm.quotaExceeded = false
  //         }
  //       },
  //       function(e) {
  //         console.log('Error', e)
  //         vm.quotaExceeded = true
  //       }
  //     )
  // },
  methods: {
    ...mapActions(['LOGOUT']),
    isRouterPath (page) {
      let path = this.$route.path
      return path.indexOf(`/${page}`) === 0 || path === page
    },
    logout () {
      this.LOGOUT().then(() => {
        this.$router.push('/')
      })
    },
    sync () {
      this.$router.push('sync')
    },
    formatBytes (a, b) {
      if (a === 0) return '0 Bytes'
      var c = 1024
      var d = b || 2
      var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var f = Math.floor(Math.log(a) / Math.log(c))
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic");

html,
body,
.app-viewport {
  height: 100%;
  overflow: auto;
}

.app-viewport {
  display: flex;
  flex-flow: column;
}

.main-content {
  z-index: 1;
  overflow: auto;
  height: 100%;
}

.main-toolbar {
  position: relative;
  z-index: 10;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?6cff5514